/**
 * Member-facing copy for the RM Magazine Editor's "Publish magazine" flow,
 * which regenerates the magazine and sends it to print once the render is
 * finished. afy-ui has no i18n layer; the copy is kept in one place so the flow
 * and its tests read the same text.
 */
export const magazinePublishStrings = {
  // Shown while the editor loads the magazine and its print status.
  loading: 'Loading your magazine...',
  loadingDetail: 'Please wait while we load your magazine.',
  // Shown under the publish loader while the regeneration runs.
  generating: 'Generating your magazine. This can take a few minutes.',
  sending: 'Sending your magazine to print...',
  // The wait gave up; a second click resumes waiting on the same render.
  stillGenerating:
    'Your magazine is still being prepared. Please click Publish magazine again in a minute to send it to print.',
  // The same render timed out again; the next click starts a new one.
  startOver:
    'Your magazine is taking longer than usual. Please click Publish magazine again to generate it again. If this keeps happening, contact support.',
  couldNotStart:
    'We could not start generating your magazine. Please click Publish magazine again.',
  generationFailed:
    'Your magazine could not be generated, so it was not sent to print. Please click Publish magazine again.',
  superseded:
    'A newer version of your magazine started generating, so this one was not sent to print. Please click Publish magazine again.',
  alreadySent: 'Your magazine has already been sent to print.',
};
